module.exports = __webpack_public_path__ + "images/emoji/two_women_holding_hands.b658c91754a5758cb087.png";